<template>
  <div class="section totals">
    <b-modal id="top-settings" hide-footer title="Időszak kiválasztása">
      <b-form-group
        id="top-interval"
        label="Időszak"
        label-for="top-interval-select"
        description="Válaszd ki a vizsgálandó időszakot."
      >
        <b-form-select id="top-interval-select" v-model="preferences.interval" :options="topIntervals"></b-form-select>
      </b-form-group>
    </b-modal>

    <h4 class="h4 section-title">
      <span>Kumulált megnyitási ráta alakulása a Top 5 ajánlás tükrében</span>
      <b-button-group size="sm" class="float-right">
        <b-button variant="text" @click="$bvModal.show('top-settings')">
          <i class="fas fa-tools"></i>
        </b-button>
      </b-button-group>
    </h4>
    <div class="section-content">
      <loading v-model="topLoading">
        <top :chartData="openRate"></top>
      </loading>
    </div>
    <h4 class="section-title mt-3">
      <span>Tesztelt ajánlások alakulása az elmúlt 3 hónapban</span>
    </h4>
    <div class="section-content">
      <loading v-model="recentLoading">
        <recent :chartData="recentActions"></recent>
      </loading>
    </div>
  </div>
</template>
<script>
  import Loading from '../../common/LoadingPlaceholder'
  import Top from './Top5Actions'
  import Recent from './RecentActions'

  export default {
    components: {
      'loading': Loading,
      'top': Top,
      'recent': Recent
    },
    data() {
      return {
        topLoading: true,
        recentLoading: true,
        openRate: {},
        recentActions: {},
        preferences: {
          interval: 3
        },
        topIntervals: [
          { value: 1, text: '1 hónap' },
          { value: 3, text: '3 hónap' },
          { value: 6, text: '6 hónap' },
          { value: 12, text: '12 hónap' },
        ]
      }
    },
    watch: {
      'preferences.interval': function(interval) {
        this.updateTopChart(interval)
        this.$bvModal.hide('top-settings')

        this.$root.setPreference('charts.totals.top.interval', interval)
      }
    },
    mounted() {
      this.preferences.interval = this.$root.getPreference('charts.totals.top.interval', 3)

      this.updateTopChart(this.preferences.interval)
      this.updateRecentChart()
    },
    methods: {
      updateTopChart(interval) {
        this.topLoading = true
        this.$http.get(this.$url('api.statistics.open-rate', interval))
          .then(({data}) => {
            this.openRate = data
            this.topLoading = false
          })
      },
      updateRecentChart() {
        this.recentLoading = true
        this.$http.get(this.$url('api.statistics.recent-actions'))
          .then(({data}) => {
            this.recentActions = data
            this.recentLoading = false
          })
      }
    }
  }
</script>